import { useParams } from "react-router-dom";
import { ProjectPage } from "@/app/components/projects/ProjectPage";

export default function ProjectTabularReviewsPage() {
    const { id } = useParams<{ id: string }>();
    if (!id) return null;
    return <ProjectPage projectId={id} initialTab="reviews" />;
}
